import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@plaidev/sour-react';
import type { ComponentProps, ReactNode } from 'react';
import type {} from 'react/jsx-runtime';

/** 列オプション「カナ正規化」のヘルプ本文 */
export const columnOptionNormalizeKanaHelp = '小書きカナ（ァィゥェォッ など）を通常のカナに変換します。';

/** 列オプション「複数値」のヘルプ本文 */
export const columnOptionMultiValuedHelp = '同一顧客キー内で複数行にまたがる値を配列にまとめて保存します（電話番号など）。';

/** 列振り分けテーブル「振り分け先」列のヘルプ本文（HelpTooltip の content に渡す） */
export const columnDestinationHelpContent: ReactNode = (
  <div className="flex max-w-xs flex-col gap-2 text-left text-xs">
    <p>CSV の各列を取り込み時に、顧客・契約のどちらのデータに紐づけるか（あるいは取り込まないか）を指定します。</p>
    <ul className="list-inside list-disc space-y-0.5">
      <li>顧客: エンドユーザー向けの属性として保存します。</li>
      <li>契約: 契約に紐づく属性として保存します。</li>
      <li>無視: この列は取り込みません。</li>
    </ul>
  </div>
);

type HelpTooltipProps = Omit<ComponentProps<typeof Tooltip>, 'children'> & {
  ariaLabel?: string;
  iconClassName?: string;
  /** メニュー項目内など、親のクリックへ伝播させない */
  stopPropagation?: boolean;
};

export function HelpTooltip({
  ariaLabel = '補足説明',
  iconClassName = 'size-4',
  stopPropagation = false,
  ...tooltipProps
}: HelpTooltipProps) {
  const stop = stopPropagation
    ? (e: { stopPropagation: () => void }) => {
        e.stopPropagation();
      }
    : undefined;

  return (
    <Tooltip {...tooltipProps}>
      <button
        type="button"
        aria-label={ariaLabel}
        className="inline-flex shrink-0 items-center text-default"
        onClick={stop}
        onPointerDown={stop}
      >
        <FontAwesomeIcon icon={faCircleQuestion} className={iconClassName} aria-hidden />
      </button>
    </Tooltip>
  );
}
